export default __webpack_public_path__ + "static/brass-texture-b009d4447137147545849f8d871d48e5.jpg";